import { useCountDown } from "ahooks";
import NumberCount from "../../../../components/number";
import { classNames, calcNumZodiac, calculateSpecialCodeAnimal } from "../../../../tool";
import styles from "../../index.module.scss";
import toast from "../../../../components/toast";

export default function LotteryResult(props) {
  const {
    isSeal,
    lotteryResult,
    balanceInfo,
    currentIssue,
    setState,
    preResult,
    preIssue,
    onEnd,
    dicInfo,
  } = props;

  const { stime, etime } = currentIssue || {};
  const [time, formattedRes] = useCountDown({
    targetDate: isSeal ? etime : stime,
    onEnd: onEnd,
  });
  let arrDesc = [];
  const notOpen = !(lotteryResult || [])[0] || isSeal;
  if (notOpen) {
    arrDesc = ["-", "-", "-", "-", "-", "-", "", "-"];
  } else {
    arrDesc = [
      calculateSpecialCodeAnimal(preResult[0], currentIssue?.etime), // 第一位生肖
      calculateSpecialCodeAnimal(preResult[1], currentIssue?.etime),
      calculateSpecialCodeAnimal(preResult[2], currentIssue?.etime),
      calculateSpecialCodeAnimal(preResult[3], currentIssue?.etime),
      calculateSpecialCodeAnimal(preResult[4], currentIssue?.etime),
      calculateSpecialCodeAnimal(preResult[5], currentIssue?.etime),
      "",
      calculateSpecialCodeAnimal(preResult[7], currentIssue?.etime),
    ];
  }
  return (
    <div className={styles.lotteryResult}>
      <div className={styles.resultInfo}>
        <div className={styles.left}>
          <div className={styles.userId}>ID: {balanceInfo.accountNo || ""}</div>
          <div className={styles.preIssue}>
            第{isSeal ? Number(preIssue.rowId) + 1 : preIssue.rowId}期 开奖结果
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.rightInfo}>
            <div className={styles.nextIssue}>
              第{isSeal ? Number(currentIssue.rowId) + 1 : currentIssue.rowId}
              期倒计时
            </div>
            <div className={styles.time}>
              {!isSeal ? (
                `${formattedRes.hours < 10
                  ? "0" + formattedRes.hours
                  : formattedRes.hours
                }:${formattedRes.minutes < 10
                  ? "0" + formattedRes.minutes
                  : formattedRes.minutes
                }:${formattedRes.seconds < 10
                  ? "0" + formattedRes.seconds
                  : formattedRes.seconds
                }`
              ) : (
                <div className={styles.sealText}>封盘中</div>
              )}
            </div>
          </div>
          <div
            className={styles.iconLive}
            onClick={() => {
              if (isSeal) {
                if (dicInfo.liveVideoUrl) {
                  window.open(
                    `/#/video?url=${dicInfo.liveVideoUrl}`,
                    "__blank"
                  );
                } else {
                  toast("请刷新页面重试");
                }
              } else {
                toast("未到开奖时间,请耐心等待");
              }
            }}
          >
            <img src={require("../../../../assets/imgs/new/iconLive.png")} />
          </div>
        </div>
      </div>
      <div className={styles.result}>
        <div className={styles.number}>
          {preResult.map((item, index) => {
            return item === "+" ? (
              <div className={styles.resultPlus} key={index}>
                +
              </div>
            ) : (
              <NumberCount
                isSeal={notOpen}
                width={"9.156rem"}
                height={"9.156rem"}
                className={styles.resultNumber}
                number={item}
                key={index}
              />
            );
          })}
          {preResult.length ? (
            <img
              className={styles.historyMore}
              src={require("../../../../assets/imgs/new/history_more.png")}
              onClick={() => {
                setState({
                  historyVisible: true,
                });
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div className={classNames(styles.desc, isSeal ? styles.descSeal : "")}>
          {arrDesc.map((item, index) => {
            return index === 6 ? (
              <div className={styles.resultPlus} key={index}></div>
            ) : (
              <div className={styles.resDesc} key={index}>
                {item}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
